<template>
  <div class="info-contact">
    <template v-if="!hasSent">
      <validation-observer
        ref="observer"
        tag="form"
        class="inputs-container"
        @submit.prevent="validateForm()">
        <validation-provider
          rules="required"
          slim
          mode="passive">
          <template slot-scope="{ errors }">
            <oie-base-input-v2
              v-model="fullName"
              required
              maxlength="100"
              :label="tStatic('fullName')"
              :placeholder="tStatic('fullNamePlaceholder')"
              :errors="errors"></oie-base-input-v2>
          </template>
        </validation-provider>

        <validation-provider
          rules="required|email"
          slim
          mode="passive">
          <template slot-scope="{ errors }">
            <oie-base-input-v2
              v-model="email"
              required
              maxlength="100"
              :label="tStatic('email')"
              :placeholder="tStatic('emailPlaceholder')"
              :errors="errors"></oie-base-input-v2>
          </template>
        </validation-provider>

        <validation-provider
          rules="required"
          mode="passive"
          slim>
          <template slot-scope="{ errors }">
            <oie-base-textarea
              v-model="errand"
              maxlength="500"
              :label="tStatic('errand')"
              :placeholder="tStatic('errandPlaceholder')"
              :errors="errors"></oie-base-textarea>
          </template>
        </validation-provider>

        <validation-provider
          v-slot="{errors}"
          rules="required"
          mode="passive"
          slim>
          <oie-recaptcha-v2
            ref="recaptcha"
            v-model="recaptchaResponse"
            class="info-contact__recaptcha"
            :errors="errors">
          </oie-recaptcha-v2>
        </validation-provider>

        <oie-base-action
          v-element-loader="{ endpoint: 'lead/addticket' }"
          theme="secondary"
          type="submit"
          size="large">
          {{ tStatic('sendButton') }}
        </oie-base-action>
      </validation-observer>
    </template>
    <template v-else>
      <h2 class="info-contact__sent-title">
        {{ t('errandSentTitle') }}
      </h2>
      <div class="info-contact__sent-text" v-html="t('errandSentText')"></div>
      <oie-base-action
        type="button"
        theme="secondary"
        size="large"
        @click="hasSent = false">
        {{ tStatic('sendNewErrand') }}
      </oie-base-action>
    </template>
  </div>
</template>

<script>
import httpService from '@/core/http-service'

export default {
  data: () => ({
    fullName: null,
    email: null,
    errand: null,
    hasSent: false,
    recaptchaResponse: null
  }),
  methods: {
    async validateForm() {
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        this.send()
      }
    },
    async send() {
      await httpService.post('lead/addticket', { fullname: this.fullName, email: this.email, errandtext: this.errand, recaptchaResponse: this.recaptchaResponse })
        .then((response) => {
          this.$refs.recaptcha.reset()
          if (response.data.success) {
            this.fullName = ''
            this.email = ''
            this.errand = ''
            this.recaptchaResponse = null
            this.hasSent = true
          }
        })
    }
  }
}
</script>

<style lang="scss">
.info-contact {
  position: relative;
  padding: measure(half);
  border: 1px solid color(border-gray);
  background-color: color(background-white);
}

.info-contact .inputs-container {
  max-width: 31.25rem;
}

.info-contact__sent-title {
  @include h3-semi-bold;
}

.info-contact__sent-text {
  margin-bottom: 2rem;
}

.info-contact__recaptcha {
  margin-bottom: 1rem;
}
</style>
